import { CompanySettingsController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Holiday settings.
 * @example
 * ```html
 * <salaxy-holiday-settings></salaxy-holiday-settings>
 * ```
 */

export class HolidaySettings extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {};

  /** Uses the CompanySettingsController */
  public controller = CompanySettingsController;

  /** Default template is the view  */
  public defaultTemplate = "salaxy-components/settings/HolidaySettings.html";

}
